// キャッシュにQRコード読込履歴がある場合はスタンプ獲得
export const getCacheQrcode = (key: string) => {
  const qrcode = localStorage.getItem(key)

  if (qrcode) location.href = qrcode
  return
}
